import React from 'react';
import './Valeurs.css';

const Valeurs = () => {
  const valeursData = [
    {
      id: 1,
      title: 'ÉTHIQUE PROFESSIONNELLE',
      decoratorColor: '#FFD700', // Jaune pour le décorateur à côté du titre
      bottomDecoratorColor: '#800080', // Violet pour le décorateur en bas
      texts: [
        'Chez Haag Target, l\'éthique est au centre de notre stratégie et de nos actions quotidiennes. Nous croyons que le développement durable et la réussite à long terme reposent sur des valeurs humaines fortes :',
        'respect, responsabilité, intégrité, confidentialité, loyauté et honnêteté.',
        'Ces principes structurent notre gouvernance et renforcent la relation de confiance avec nos clients, partenaires et collaborateurs.',
      ],
    },
    {
      id: 2,
      title: 'QUALITÉ ET EXCELLENCE',
      decoratorColor: '#FFD700',
      bottomDecoratorColor: '#800080',
      texts: [
        'Notre engagement envers la qualité des services et produits est total. À chaque étape, nous visons l\'excellence à travers une amélioration continue, en conformité avec les normes et standards internationaux.',
        'Nous mettons en œuvre une méthodologie rigoureuse, cohérente et exigeante, garantissant la satisfaction client et la performance durable de nos solutions. L\'adaptation aux marchés exige un alignement continu avec les normes de qualité mondiales concernant les produits, services, processus et fonctionnement.',
        'La qualité découle d\'un effort soutenu, rigoureux et constant à toutes les étapes et dans les moindres détails du processus.',
      ],
    },
    {
      id: 3,
      title: 'CRÉDIBILITÉ ET TRANSPARENCE',
      decoratorColor: '#FFD700',
      bottomDecoratorColor: '#800080',
      texts: [
        'Dans un monde où les données orientent les décisions, nous plaçons la fiabilité de l\'information et la transparence des processus au cœur de notre démarche.',
        'Nous valorisons la véracité des données, la clarté de la communication et la confiance mutuelle, piliers d\'un environnement professionnel solide et pérenne.',
      ],
    },
  ];

  return (
    <div className="valeurs-section">
      <div className="section-title-container">
        <h2>
          <span className="corner top-left" />
          <span className="corner top-right" />
            Nos Valeurs
          <span className="corner bottom-left" />
          <span className="corner bottom-right" />
        </h2>
      </div>
      <div className="valeurs-container">
        {valeursData.map((valeur) => (
          <div key={valeur.id} className="valeur-card">
            <div className="card-title-container">
              <span
                className="card-title-decorator"
                style={{ backgroundColor: valeur.decoratorColor }}
              ></span>
              <h3>{valeur.title}</h3>
            </div>
            <div className="card-content">
              {valeur.texts.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>
            <span
              className="card-bottom-decorator"
              style={{ backgroundColor: valeur.bottomDecoratorColor }}
            ></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Valeurs;